<template>

  <div ref="gi-container" class="container" :class='{"min-size":loading,"hidden":!show}'>

   <div class="rotation-container" :style="calculateRotatorSize">
       
    <img @error="imageLoadError" @load="imageLoaded" :src="getMediaUrl" :style="calculateOrientation">
   
  </div>
 
    <div v-if="uploading || loading" class="loader">
      
      <div class="load-text" v-if="loading">{{$t('language.loading')}}</div>
      <div class="load-text" v-if="uploading">{{$t('language.uploading')}}</div>
      <spinner color="#FFFFFF"/>
    </div>

  </div>
</template>

<script>


import { eventBus } from "../../services/EventBus.js";
import Spinner from '../Spinner.vue';
//import { imagePicker } from '../../services/ImagePicker.js';
import anime from 'animejs/lib/anime.es.js';

export default {
  name: 'gallery-image',
  props:{
    media:{},
    index:{default:0},
    total:{default:0},
  },
  data(){
    return {
      element:undefined,
      loading:true,
      uploading:false,
      show:true, // true at first to enable image loading
      thumbnail:undefined,
      scaleCss:"",
      rotationCss:"",
      rotatorWidth:0,
      rotatorHeight:0,
      scalar:0,
      imageHasLoaded:false,
    }
  },
  components: {
    Spinner
  },
  computed:{
    getMediaUrl(){
     
      return this.thumbnail;
    },
    computeContainerStyle(){
      if(this.thumbnail){
        // automatich width for thumbnail
        return {width:"auto"}
      }
      return {};
    },
    calculateOrientation(){
      return {};//{transform:this.scaleCss+" "+this.rotationCss}
    },
    calculateRotatorSize(){
      return {};//{width:this.rotatorWidth+"px"}
    }
  },
  created(){
    
  },
  methods:{
    imageLoadError(e){
      e.target.src=require('../../assets/cdv_trollface.jpg');
      this.loading=false;
    },
    imageLoaded(e){
     
      this.show=true;
      // set css rotation of image
      this.applyExifRotation(e.target);

      // update scroll menu on image load to calculate the correct width size
      //eventBus.$emit('UPDATE_SCROLL_MENU');
       this.loading=false;
       //this.emitNext();
    },
    applyExifRotation(imageElement){
    
    var container=this.element;
    

    var r=0;
    this.scalar;//=(this.naturalWidth/this.naturalHeight);
    var exifOrientation=parseInt(this.media.exifOrientation);
   
   
    //alert("aer"+exifOrientation)
    // calculate rotator scale.
    switch(exifOrientation){
      case 1: r=0; this.scalar=(container.clientHeight/imageElement.naturalHeight); break;
      case 8: r=-90; this.scalar=(container.clientHeight/imageElement.naturalWidth); break;
      case 3: r=180; this.scalar=(container.clientHeight/imageElement.naturalHeight);break;
      case 6: r=90; this.scalar=(container.clientHeight/imageElement.naturalWidth); break;
      default: r=0; this.scalar=(container.clientHeight/imageElement.naturalHeight); break;
    }


    var imgScalar;
  
   if (Math.abs(r)===90){ // 90 or -90
      this.rotationCss="rotate("+r+"deg)";

      this.rotatorWidth=imageElement.naturalHeight*this.scalar;
      
      imgScalar=imageElement.naturalHeight/imageElement.naturalWidth;
      this.scaleCss="scale("+imgScalar+")";
     
    }else{ // 180 and 0 degrees
     this.rotationCss="rotate("+r+"deg)";
     
      this.rotatorWidth=imageElement.naturalWidth*this.scalar;
      imgScalar=1;
      this.scaleCss="scale("+imgScalar+")";
    }

    

    },
    loadImage(){
     
     if(this.imageHasLoaded){

       return;
     }
    //if(currentIndex!=this.index){ return; }

    //console.log("load",this.media.thumbnail)
  
    this.thumbnail=this.media.thumbnail;
    //imagePicker.isBase64(this.media.url)
      // is already base64, must be a dummy image, dont resize.
    /*
    if(imagePicker.isBase64(this.media.url)){
      this.thumbnail=this.media.url;
      
    }else{
      imagePicker.resizeUrlToBase64(this.media.url,500).then(result=>{
        
        this.thumbnail=result;
        // emit for next
        
      })
    }
    */
    this.animateIn();

    this.imageHasLoaded=true;

    },
    animateIn(){
      this.element.style.transform="scale(0)"
    
      anime({
          targets: this.element,
          opacity: 1,
          scale:1,
          duration: 350,
          easing:"easeInOutCirc",
        }).finished.then(()=>{
          
        });
    },
    animateOut(){
      anime({
          targets: this.element,
          opacity: 0,
          scale:0,
          duration: 350,
          easing:"easeInOutCirc",
        }).finished.then(()=>{
          this.show=false;
        });
    }
    
  },

  beforeDestroy(){
    eventBus.$off("MEDIA_UPLOAD_START");
    eventBus.$off("MEDIA_UPLOAD_DONE");
  },
  mounted(){
   
    this.element=this.$refs['gi-container'];
   
    eventBus.$on("MEDIA_UPLOAD_START",payload=>{
      if(this.media.url===payload.media.url){
        this.uploading=true;
      }
     });

    eventBus.$on("MEDIA_UPLOAD_DONE",payload=>{
      if(this.media.url===payload.media.url){
        this.uploading=false;
        this.animateOut();
      }
     });


    this.loadImage();
/*
     eventBus.$on("UPLOAD_GALLERY_LOAD_NEXT",payload=>{
      
      // allow at least 100 milliseconds between animation
      setTimeout(()=>{
        this.nextSequentialLoad(payload.index);
      },100);
       

     })
    
    this.nextSequentialLoad(0);
    */
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container{
  margin:2px;
  position:relative;
  display:inline-block;
  width:auto;
  height:150px;
  border:5px solid #EEEEEE;
  opacity:1;
  transform:scale(1);
  cursor:pointer;
}

.rotation-container{
  position:relative;
  /*
    100px width was to rotate photo in css..
  /*width:100px;*/ 
  height:100%;
  display:flex;
  justify-content:center;
  align-items: center;
  overflow:hidden;
}
.min-size{
  width:100px;
}

.loader{
  z-index:1;
  position:absolute;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background-color:rgba(0,0,0,.4);
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.load-text{
 display:inline-block;
  font-size:.7em;
  color:#FFFFFF;
}
img{
  display:block;
  width:auto;
  height:100%;
}
.hidden{
  display:none;
}

</style>
